export default __webpack_public_path__ + "static/rip_purple-7895b4a30ed55edbcab54e5551aa6b03.svg";